import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { FacultyEdit } from '@/module/Faculty/FacultyEdit';
import { getFacultyOptions } from '@/module/Faculty/model/FacultyQuery';

export const Route = createFileRoute('/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { facultyId } = Route.useParams();
  const { data: faculty } = useSuspenseQuery(getFacultyOptions(facultyId));

  return <FacultyEdit faculty={faculty} />;
}
